import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, ModalBody } from 'reactstrap';

class ConfirmationComponent extends PureComponent {
  render() {
    return (
      <Fragment>
        <ModalBody>
          <div className="confirmation">
            <div className="confirmation__text pb-3">{this.props.confirmationText}</div>
            <div className="form__btn-container">
              <Button color={this.props.confirmButtonColor} onClick={this.props.onConfirm}>
                {this.props.confirmText}
              </Button>
              <Button
                color={this.props.cancelButtonColor}
                onClick={this.props.onCancel}
                className="mr-3"
              >
                {this.props.cancelText}
              </Button>
            </div>
          </div>
        </ModalBody>
      </Fragment>
    );
  }
}

ConfirmationComponent.propTypes = {
  confirmationText: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelButtonColor: PropTypes.string,
  cancelText: PropTypes.string,
  confirmButtonColor: PropTypes.string,
  confirmText: PropTypes.string,
};

ConfirmationComponent.defaultProps = {
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  cancelButtonColor: 'link',
  confirmButtonColor: 'danger',
};

export default ConfirmationComponent;
